function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4EAD47",
  fillRule: "evenodd",
  d: "M22.2669683,15.1264755 L22.2669683,7.38617201 C22.2669683,3.30688027 19.0133575,0 15,0 C10.986543,0 7.73303167,3.30688027 7.73303167,7.38617201 L7.73303167,9.61214165 L11.4162896,9.61214165 L11.4162896,7.38617201 C11.4162896,5.37450253 13.0207964,3.74367622 15,3.74367622 C16.9792036,3.74367622 18.5837104,5.37450253 18.5837104,7.38617201 L18.5837104,15.1264755 L4,15.1264755 L4,30 L26,30 L26,15.1264755 L22.2669683,15.1264755 Z"
});

function SvgIconAssortmentUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssortmentUnlock);
export default __webpack_public_path__ + "static/media/icon_assortment_unlock.0a4f9eb9.svg";
export { ForwardRef as ReactComponent };